import { useCallback, useMemo } from 'react'

import B2becCustomSelect from '@/components/B2becCustomSelect'
import { useAppSelector } from '@/store/hook'
import { selectCountryNames } from '@/store/selectors/configSelector'
import { mergeIntoStringWithSeparator } from '@/libs/utils/array'

const AddressSelect = (props) => {
  const { deliveryAddresses, placeholder, onChange } = props

  const countryNames = useAppSelector(selectCountryNames)

  const mergeAddress = useCallback(
    (address) => {
      const {
        partnerNumber = '',
        name = '',
        name2 = '',
        name3 = '',
        street = '',
        houseNumber = '',
        street4 = '',
        zip = '',
        city = '',
        country = '',
      } = address

      const foundConfigForName = countryNames.find(
        (countryNameConfig) => countryNameConfig.value === country,
      )
      const countryName = foundConfigForName ? foundConfigForName.name : ''

      return mergeIntoStringWithSeparator()(
        partnerNumber,
        name,
        name2,
        name3,
        street,
        houseNumber,
        street4,
        zip,
        city,
        countryName,
      )
    },
    [countryNames],
  )

  const addressArray = useMemo(() => {
    const initialArray = [
      {
        key: 0,
        value: 0,
        label: placeholder,
      },
    ]

    return (deliveryAddresses ?? []).reduce((array, address, index) => {
      array.push({
        key: index + 1,
        value: index + 1,
        label: mergeAddress(address),
      })
      return array
    }, initialArray)
  }, [deliveryAddresses, placeholder, mergeAddress])

  const handleChange = useCallback(
    (selectedId) => {
      const selected = deliveryAddresses[selectedId - 1]
      onChange(selected, selectedId)
    },
    [deliveryAddresses, onChange],
  )

  return (
    <B2becCustomSelect
      options={addressArray}
      placeholder={placeholder}
      style={{ width: '100%' }}
      onChange={handleChange}
      onClick={(e) => {
        e.preventDefault()
      }}
    />
  )
}

export default AddressSelect
